import styled from "styled-components";

/**
 * Wrapper do componente Stops
 * Define o layout geral, garantindo alinhamento e espaçamento consistente.
 */
export const StyledStopsWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isMobile"].includes(prop as string),
})<{ isMobile?: boolean }>`
  min-width: ${({ theme, isMobile }) =>
    !isMobile ? theme.spacing(10) : theme.spacing(10)};
  align-items: center;
  display: flex;
`;

/**
 * Linha de Paradas
 * Exibe uma linha horizontal com dots representando as paradas.
 */
export const StyledStopsLine = styled.div.withConfig({
  shouldForwardProp: (prop) => !["color"].includes(prop),
})<{ color: string }>`
  border-radius: ${({ theme }) => theme.borderRadius.extraLarge};
  height: ${({ theme }) => theme.spacing(0.4)};
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;

  /* Linha contínua caso stops seja 0 */
  ${({ color }) => color && `background-color: ${color};`}
`;

/**
 * Dot representando uma parada
 * Exibe um círculo estilizado para cada parada.
 */
export const StyledStopsDot = styled.div.withConfig({
  shouldForwardProp: (prop) => !["color"].includes(prop),
})<{ color: string }>`
  background-color: ${({ color }) => color};
  width: ${({ theme }) => theme.spacing(1.5)};
  height: ${({ theme }) => theme.spacing(1.5)};
  border-radius: 50%;
`;

/**
 * Ícone do Avião
 * Exibe um ícone estilizado com a mesma cor dos dots e da linha.
 */
export const StyledIcon = styled.div.withConfig({
  shouldForwardProp: (prop) => !["color"].includes(prop),
})<{ color: string }>`
  padding-top: ${({ theme }) => theme.spacing(0.5)};

  & > svg {
    font-size: ${({ theme }) => theme.spacing(2)};
    margin-left: ${({ theme }) => theme.spacing(0.5)};
    color: ${({ color }) => color};
    transform: rotate(90deg);
  }
`;
